<template>
  <div class="wrap">
    <mt-header title="帐号安全">
      <router-link to="" slot="left" tag="div">
        <span class="back" @click.stop="back"></span>
      </router-link>
      <span slot="right" @click="finish" v-bind:class="{'selected': true, 'selected-t': opacity}">{{index}}</span>
    </mt-header>
    <div class="main" @click="goFirst">
      <mt-cell title="修改登录密码" is-link v-show="isshow"></mt-cell>
    </div>
    <div class="revise" v-show="!isshow">
      <form action="">
        <div class="errowShow" v-if="isShow">{{tishi}}</div>
        <div class="tip_info" v-if="!isShow">请输入新的密码</div>
        <div class="form-group">
          <label class="label">旧密码</label>
          <input ref="input1" type="password" placeholder="请输入旧密码" v-model="password"
                 v-on:focus="focusPassword" class="inputForm" maxlength="16">
        </div>
        <div class="form-group">
          <label class="label">新密码</label>
          <input ref="input2" type="password" placeholder="请输入8位以上数字字母特殊符号组合" v-model="newPassword" @blur="changeNewpassword"
                 @focus="focusNewpassword" class="inputForm" maxlength="16">

        </div>
        <div class="form-group">
          <label class="label">新密码</label>
          <input ref="input3" type="password" placeholder="请输入再次输入新密码" v-model="confirm_password"
                 v-on:mousedown="focusConfirmpassword"
                 class="inputForm" maxlength="16">
        </div>
      </form>
    </div>

  </div>
</template>
<script>
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import { Toast } from 'mint-ui'
  import crypto from '@/utils/crypto'

  export default {
    data () {
      return {
        isshow: true,
        isShow: false,
        isA: true,
        tishi: '',
        password: '',
        newPassword: '',
        confirm_password: '',
        index: '',
        form: '',
        rules: {
          password: [
            {
              required: true,
              message: '请输入旧密码',
              trigger: 'blur'
            }
          ],
          newPassword: [
            {
              required: true,
              message: '请输入新密码',
              trigger: 'blur'
            }
          ]
        }
      }
    },
    computed: {
      opacity () {
        return this.password && this.newPassword && this.confirm_password && !this.isShow
      }
    },
    components: {
      Toast
    },
    methods: {
      back () {
        if (this.isshow) {
          this.$router.push('/more/setinfo')
        } else {
          this.isshow = true
        }
      },
      goFirst: function () {
        this.isshow = false
        this.index = '完成'
      },
      focusPassword () {
        this.isShow = false
      },
      changeNewpassword () {
        var reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!-\/:-@\[-`{-~])[!-~]{8,20}$/
        var _this = this
        if (_this.newPassword.length === 0) {
          _this.isShow = true
          _this.tishi = '密码不能为空'
          return false
        }
        if (_this.newPassword.length < 6) {
          _this.isShow = true
          _this.tishi = '密码长度不能小于6个字符'
          return false
        }
        if (_this.newPassword.length > 16) {
          _this.isShow = true
          _this.tishi = '密码长度不能大于16个字符'
          return false
        }
        if (!reg.test(_this.newPassword)) {
          _this.isShow = true
          _this.tishi = '密码必须是8-16位字母、数字和符号三种组合'
          return false
        }
      },
      focusNewpassword () {
        this.isShow = false
//        this.opacity = true
      },
      focusConfirmpassword () {
        this.isShow = false
        if (this.password !== '' && this.newPassword !== '') {
        }
      },
      finish () {
        const validate = this.changeNewpassword()
        if (validate === false) {
          return validate
        }
        if (this.password !== '' && this.newPassword !== '') {
          this.isA = false
          if (this.confirm_password.trim() === '') {
            this.isShow = true
            this.tishi = '请输入新密码'
            return false
          }
          if (this.confirm_password !== this.newPassword) {
            this.isShow = true
            this.tishi = '两次密码输入不一致'
            return false
          } else {
            this.isShow = false
            var oldPassword = this.password
            var value = this.newPassword
            var _this = this
            apis.request(cloudApi.info, {value: crypto.Encrypt(value), type: 4, oldPassword: crypto.Encrypt(oldPassword)}).then(function (response) {
              Toast({
                message: '修改成功',
                iconClass: 'icon-success'
              })
              _this.password = ''
              _this.newPassword = ''
              _this.confirm_password = ''
//            let instance = Toast('修改成功')
//            setTimeout(() => {
//              instance.close()
//            }, 2000)
              _this.isshow = true
              _this.isA = true
            }).catch(function (error) {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
              _this.password = ''
              _this.isA = true
//            let instance = Toast(error.response.data.message)
//            setTimeout(() => {
//              instance.close()
//            }, 2000)
            })
          }
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import "../../assets/css/variable";
  body {
    font-size: 0.16rem !important;
  }

  .wrap {
    padding-top: 1.28rem;
    height: 100%;
  }

  .mint-header {
    height: 1.28rem;
    font-size: .36rem;
    background-color: $topbar-background-color;
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1;
    top: 0;
  }

  .back {
    width: .2rem;
    height: .3rem;
    /*margin-left: .3rem;*/
    background: url("../../assets/images/back.png") no-repeat;
    background-size: .2rem .3rem;
    float: left;
    margin-top: .1rem;
  }

  .main {
    margin-top: .2rem;
  }

  .form-group {
    width: 100%;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    height: .88rem;
    line-height: .88rem;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 .3rem;
    background: #fff;

  }

  .label {
    color: #000000;
    font-size: .28rem;
    width: 1.36rem;
    text-align: left;
    display: inline-block;
  }

  .inputForm {
    display: inline-block;
    font-size: .28rem;
    border: 0;
    border-radius: 0;
    position: absolute;
    top: .3rem;
    outline: 0;
    color: #b2b2b2;
    padding-left: .28rem;
  }

  .tip_info {
    width: 100%;
    height: .7rem;
    font-size: .3rem;
    line-height: .7rem;
    padding: 0 .3rem;
  }

  .selected {
    color: #fff !important;
    font-size: 0.3rem;
    opacity: 0.3;
    background: inherit !important;
  }

  .selected-t {
    opacity: 1;
    font-size: 0.3rem;
  }

  .icon-success {
    background: url("../../assets/images/success_icon.png") center no-repeat;
    background-size: 0.98rem 0.7rem;
    margin: 0 auto;
    width: 0.98rem;
    height: 0.7rem;
  }

  .icon-error {
    background: url("../../assets/images/x.png") center no-repeat;
    margin: 0 auto;
    width: 0.98rem;
    height: 0.7rem;
  }

  .errowShow {
    width: 100%;
    top: .88rem;
    bottom: 0;
    left: 0;
    right: 0;
    height: .7rem;
    background: #e64340;
    font-size: .3rem;
    color: white;
    text-align: center;
    line-height: .5rem;
    padding: .1rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/more/accountsafe.vue